import { useCallback, useState } from "react";
import cx from "classnames";
import { getShortenAddress } from "@/helpers";
import { SvgIcon } from "../SvgIcon";
import styles from "./AddressShorter.module.sass";

interface AddressShorterProps {
  address: string;
  className?: string;
}

export const AddressShorter = ({ address, className }: AddressShorterProps) => {
  const [isCopied, setIsCopied] = useState(false);

  const handleOnCopy = useCallback(() => {
    navigator.clipboard.writeText(address);

    setIsCopied(true);

    const timeout = setTimeout(() => {
      setIsCopied(false);
    }, 1000);

    return () => clearTimeout(timeout);
  }, [address]);

  const classes = cx(styles.address, {
    [styles['is-copied']]: isCopied,
  }, className);

  return (
    <div className={classes}>
      <div className={styles.value}>{getShortenAddress(address)}</div>

      <button type="button" className={styles.copy} title="Copy Address" onClick={handleOnCopy}>
        <SvgIcon name={isCopied ? "checkbox" : "copy"} />
      </button>
    </div>
  );
};